/* eslint-disable react/jsx-no-useless-fragment */
export interface AscAdminBreadcrumbItemProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  innerTextClassName?: string;
  loading?: boolean;
  onClick?: () => void;
}

export function AscAdminBreadcrumbItem({ children }: AscAdminBreadcrumbItemProps) {
  return <>{children}</>;
}
